<template>
  <div class="my-tab2-inner" :class="{'my-tab2-inner-checked':showType}" @click="clickTab">
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1>
export default {
  name: 'TabInner2',
  props: {
    showType: {
      type: Boolean
    }
  },
  data () {
    return {

    }
  },
  methods: {
    clickTab (item) {
      this.$emit('click', item)
    }
  },
  mounted () {
  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-tab2-inner{
  height: 40px;
  line-height: 40px;
  padding: 0 25px;
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  border-top:1px solid rgba(228,231,237,1);
  border-bottom:1px solid rgba(228,231,237,1);
  border-right:1px solid rgba(228,231,237,1);
  cursor: pointer;
  color: #333333;
  font-size:14px;
  font-weight:400;

  &:hover{
    color: #0286df;
  }
  &:nth-child(1){
    border-left:1px solid rgba(228,231,237,1);
    border-radius:4px 0px 0px 0px;
  }
  &:last-child{
     border-radius:0px 4px 0px 0px;
  }
}
.my-tab2-inner-checked{
 color: #0286df;
 border-bottom:1px solid #fff;
}
</style>
